import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ReponseWebService } from 'app/datastruct/Meloyi.module';
import { ServicepoolService } from 'app/services/servicepool.service';
import { formatDate } from "@angular/common";

@Component({
  selector: 'app-printproposition',
  templateUrl: './printproposition.component.html',
  styleUrls: ['./printproposition.component.css']
})
export class PrintpropositionComponent implements OnInit {

	detailsCommande = [] ;

	retourClientWS  : ReponseWebService ;

	productionElt : any ;

	theProduction : any ;
	infosProd : any ;
	autresinfos : any ;
	garanties : any ;
	montantdevis : any ;
	prenom : any ;
	nom : any ;

	partners = [] ;
	partner : any ;
	current = 0 ;

	today : any ;
	assure : any ;

	samacaabiyoonwii : any ;
	codeemetteur : any ;
	agence : any ;

	propositionRetenue : any ;

	reimpr : any ;

	getDateFormatFrench(datebi){
	if(datebi!=undefined){
	  let datebiDoug = new Date(datebi) ;
	  let weerwi = datebiDoug.toLocaleString('fr-FR', { month: 'long' });
	  let jourBi = datebiDoug.getDate() ;
	  let anneeBi = datebiDoug.getFullYear() ;
	  return jourBi+" "+weerwi+" "+anneeBi ;
	}else
	  return "" ;
	}

	constructor( private configServer: ServicepoolService, public dialogRef: MatDialogRef<PrintpropositionComponent>, public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any ) {
	    this.souscription = data.souscription;
	    this.assure = data.assure ;
	    let tayyDji =  new Date() ;
	    this.today =  formatDate(tayyDji, "yyyy-MM-dd", 'en-US');
	    
		this.productionElt = data.element ;

	    this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii") ;
	    this.codeemetteur = sessionStorage.getItem("codeemetteur") ;
	    this.agence = sessionStorage.getItem("agence") ;

        if(data.datecreation!=undefined)
        	this.reimpr = data.datecreation ;

		console.log("Incoming!! : ", data) ;
		console.log("souscription!! : ", this.souscription.refPolice) ;
	}




  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById("printer").innerHTML;
    popupWin = window.open('', '_blank', 'left=0,top=0,height=800,width=800,innerheight=800,innerwidth=1000');
    popupWin.document.open();
    popupWin.document.write(`
          <html>
              <head>
                  <style>
                      //........Customized style.......
                      
                  </style>
              </head>
              <body onload="window.print();window.close()">${printContents}<br/><h4 style="text-align: center"></h4><br/><br/><hr/><br/><p></body>
          </html>`
    );
    popupWin.document.close();
  }
 
  dataImpression
  dataToPrint
  operateur

  prenomi;
  nomi;
  profession;
  adresse;
  genre;
  marque;
  type;
  immat;
  police;
  duree;
  dureeEnJour;
  souscription;
  displayDate(date,type){
    if(type == "du"){
      return date.split("T")[0].split("-")[2]+"-"+date.split("T")[0].split("-")[1]+"-"+date.split("T")[0].split("-")[0]
    }else{
      let dd = new Date(date);
      let f = dd.setDate(dd.getDate()+parseInt(this.dureeEnJour));
      let ddd = ((new Date(f)).toJSON()).split("T",2)[0];
      return ddd.split("T")[0].split("-")[2]+"-"+ddd.split("T")[0].split("-")[1]+"-"+ddd.split("T")[0].split("-")[0]
    }

  }
	ngOnInit(): void {

	   this.dataToPrint = this.productionElt
	   this.prenom = this.dataToPrint.prenomAssure+" "+this.dataToPrint.nomSouscrip;
	   this.profession = "";
	   this.adresse = "";

	   if(this.reimpr!=undefined){
			this.marque = this.assure.marque;
			this.type = this.assure.modele;     
			this.immat = this.souscription.immatricule;
			this.police = this.souscription.refPolice;
			this.duree = this.dataToPrint.duree;

			console.log(this.immat, this.police, this.duree)

	   }else{
		   this.marque = this.dataToPrint.marque;
		   this.type = this.dataToPrint.modele;     
		   this.immat = this.dataToPrint.immatriculation;
		   this.police = this.souscription.numeroPolice;
		   this.duree = this.dataToPrint.dateEffet;
	   }

	   this.dureeEnJour = this.dataToPrint.dateEcheance;

       this.operateur = JSON.parse(sessionStorage.getItem('currentUser'));

       if(this.reimpr == undefined){
	       this.getpropbyCurrentHYOU(this.samacaabiyoonwii, this.productionElt.currentHYIOU) ;
       }
	   else{
	   	   this.propositionRetenue = JSON.parse(this.souscription.infoSup) ;
	   	   console.log("reimpr:: Proven To Not be undefined ! ", this.propositionRetenue ) ;
	   }


	}



	getCatFrom(genre){
		if(this.reimpr==undefined)
			return genre.split("|")[0] ;
		else
			return this.assure.categ
	}

	annuler(){
		this.dialogRef.close() ;
	}

	getDetailProdLine(idprod){
		this.configServer.getDetailProdLine(idprod).then( (retourbi) => {

		    this.retourClientWS = retourbi ;
		    var statutrec = this.retourClientWS.statutreq ;
			//console.log(this.retourClientWS)
		    if(statutrec==1){
		    	this.theProduction = this.retourClientWS.data[0] ;
				//console.log(this.theProduction)
				this.infosProd = JSON.parse(this.theProduction.infos) ;
				this.autresinfos = JSON.parse(this.theProduction.autresinfos) ;
				this.garanties = JSON.parse(this.theProduction.garanties) ;
				this.montantdevis = this.theProduction.montantdevis ;
				this.prenom = this.theProduction.prenom ;
				this.nom = this.theProduction.nom ;
			    console.log(this.theProduction.infos) ;  
		    }
		    else
		      console.log("Failed") ;
		}) ;    
	}


	getpropbyCurrentHYOU(samacaabiyoonwii, currentHYIOU){
		this.configServer.getpropbyCurrentHYOU(samacaabiyoonwii, currentHYIOU).then( (retourbi) => {
		    this.retourClientWS = retourbi ;
		    var statutrec = this.retourClientWS.statutreq ;
		    if(statutrec==1){
		    	this.propositionRetenue = this.retourClientWS.data ;
			    console.log(this.propositionRetenue) ;  
		    }
		    else
		      console.log("Failed") ;
		}) ;    
	}


	getThisValueFromProps(valueName){
		for (var i = 0; i < this.propositionRetenue.allvalues.length; i++) {
			if(this.propositionRetenue.allvalues[i].nomvariable==valueName)
				return this.propositionRetenue.allvalues[i].valeur ;
		}
		return undefined ;
	}



	getValueForGarantie(garantieName){
		for (var i = 0; i < this.propositionRetenue.details.length; i++) {
			if(this.propositionRetenue.details[i].nomgarantie==garantieName)
				return this.propositionRetenue.details[i].devis ;
		}
		return undefined ;
	}



	formatNbrPlace(nbrePlace){
		return nbrePlace.split(".")[0] ;
	}


  getMontantFormatee(montant){
    let resultd = Number(montant).toLocaleString('fr-FR');
    if(resultd!="NaN")
	    return resultd ;
	else
		return "";
  }

}
